import { validSeoPath } from 'shared/util/formatting';

type SeoPlace = {
    country?: string;
    city?: string;
    image: string;
};

export const toDestinations = (places: SeoPlace[], cdnPath: string, basePath: string, altPrefix: string) =>
    places.map((place) => {
        const label = place.city ?? place.country ?? '';
        return {
            image: `${cdnPath}${place.image}.jpg`,
            label,
            alt: `${altPrefix} ${label}`,
            href: `${basePath}${validSeoPath(place.country ?? '')}/${place.city ? `${validSeoPath(place.city)}/` : ''}`,
        };
    });
